const FETCH_LIST_REQUEST = 'FETCH_LIST_REQUEST_B'
const FETCH_LIST = 'FETCH_LIST_B'
const FETCH_ERROR = 'FETCH_ERROR_B'
const FETCH_LIST_PASS = 'FETCH_LIST_PASS_B'
//BORROWED BOOKS DATA
const FETCH_BORROWED_REQUEST = 'FETCH_BORROWED_REQUEST_B'
const FETCH_BORROWED_PASS = 'FETCH_BORROWED_PASS_B'
// adding new book
const ADD_NEW_BOOK = 'ADD_NEW_BOOK'

const CLEAR_ERRORS = 'CLEAR_ERRORS_B'

export {
  FETCH_LIST,
  FETCH_LIST_REQUEST,
  FETCH_LIST_PASS,
  FETCH_ERROR,
  FETCH_BORROWED_REQUEST,
  FETCH_BORROWED_PASS,
  ADD_NEW_BOOK,
  CLEAR_ERRORS,
}
